"use client";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import useQueryString from "@/hooks/useQueryString";

interface DeleteConfirmationProps {
  deleteFn: () => void;
  isOpen: boolean;
  onClose: () => void;
}

const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({
  deleteFn,
  isOpen,
  onClose,
}) => {
  const handleDelete = () => {
    deleteFn();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md ">
        <DialogHeader>
          <DialogTitle>Do you really want to delete this chat?</DialogTitle>
        </DialogHeader>
        <DialogFooter className="justify-end">
          <DialogClose asChild>
            <Button
              type="button"
              className="dark:bg-neutral-700 hover:dark:bg-neutral-600"
              variant="secondary"
              onClick={onClose}
            >
              No
            </Button>
          </DialogClose>
          <Button type="button" onClick={handleDelete}>
            Yes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteConfirmation;
